module.exports = __webpack_public_path__ + "img/1abf896.svg";